/** Guards fleet chat.inject side-effects during session transitions and history reloads. */
export type FleetAutoInjectHost = {
  chatLoading?: boolean;
  chatFleetAutoInjectHeld?: boolean;
};

export function isFleetAutoInjectSuppressed(host: FleetAutoInjectHost): boolean {
  return Boolean(host.chatLoading || host.chatFleetAutoInjectHeld);
}
